module.exports = __webpack_public_path__ + "img/Group_6.65778a74.png";